module.exports = "/_next/static/images/document-line-83042df42d768b6e242acd19b0f81278.svg";